import React, { useContext, useEffect, useState } from 'react';
import { HttpMethods, FetchContext, ApiRoutes } from '../../../contexts';
import { useAggregatedState } from './../../../../helpers';

export const BudgetContext = React.createContext(null);
const { Provider } = BudgetContext;

export const BudgetProvider = ({ ...props }) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({
        isLoadingBudgetSessions: false,
        budgetSessions: null,
        addedYear: null
    });

    const getBudgetSessionsAsync = async () => {
        try {
            setState({ isLoadingBudgetSessions: true });
            const budgetSessionsApi = await fetchAuthorized(ApiRoutes.Budget.GetBudgetSessions({ pageSize: 1000 }),
            {                    
                method: HttpMethods.GET
            }); 
    
            const budgetSessions = await budgetSessionsApi.json();
            setState({ budgetSessions, isLoadingBudgetSessions: false });
        }
    
        catch (ex){
            setState({ isLoadingBudgetSessions: false });
            console.error(ex);
            console.error(ex.details);
        }
    }

    const addNewBudgetYearAsync = async (data) => {
        try {            
            const newYearApi = await fetchAuthorized(ApiRoutes.Budget.AddNewBudgetYear(),
            {                    
                method: HttpMethods.POST,
                body: JSON.stringify(data),
                collectErrorDetails: true
            }); 
    
            const addedYear = await newYearApi.json();
            setState({ addedYear });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    const getProjectsAmountAsync = async (data) => {
        try {            
            const projectsAmountApi = await fetchAuthorized(
                ApiRoutes.Projects.GetProjectsAmount({ year: data.year }),
                { method: HttpMethods.GET }
            ); 
    
            const projectsAmount = await projectsAmountApi.json();
            return projectsAmount;
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    const advanceBudgetYearAsync = async (data) => {
        try {            
            const advanceYearApi = await fetchAuthorized(
                ApiRoutes.Budget.AdvanceBudgetYear(),
                {                    
                    method: HttpMethods.POST,
                    body: JSON.stringify(data),
                    collectErrorDetails: true
                }
            ); 
    
            const isSuccessfulAdvanced = await advanceYearApi.json();
            return isSuccessfulAdvanced;
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    const copyProjectsAsync = async (data) => {
        try {            
            const copyProjectsApi = await fetchAuthorized(
                ApiRoutes.Projects.CloneProjectsToNextYear(data),
                {                    
                    method: HttpMethods.POST,
                    collectErrorDetails: true
                }
            ); 
    
            const copiedProjects = await copyProjectsApi.json();
            return copiedProjects;
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    const deleteBudgetYearAsync = async (data) => {
        try {            
            await fetchAuthorized(ApiRoutes.Budget.DeleteBudgetYear({ budgetYearId: data }),
            {                    
                method: HttpMethods.DELETE
            });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    return (
        <Provider value={{
            state,
            getBudgetSessionsAsync,
            addNewBudgetYearAsync,
            getProjectsAmountAsync,
            advanceBudgetYearAsync,
            copyProjectsAsync,
            deleteBudgetYearAsync
        }}>
            {props.children}
        </Provider>
    );
}